<template>
  <v-tooltip :disabled="isNavigationMenuExpanded || !$slots.tooltip" offset="6">
    <template #activator="{ props }">
      <v-list-item
        v-bind="props"
        class="scope-selector"
        :link="hasLink"
        @click="$emit('click')"
        data-cc="nav-scope-selector"
      >
        <!-- Prepend slot -->
        <template #prepend>
          <slot name="prepend" />
        </template>

        <!-- Title slot -->
        <v-list-item-title>
          <slot />
        </v-list-item-title>

        <!-- Append slot -->
        <template #append>
          <v-list-item-action end>
            <slot name="append" />
          </v-list-item-action>
        </template>
      </v-list-item>
    </template>

    <span class="text-body-2">
      <slot name="tooltip" />
    </span>
  </v-tooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import useNavigationStore from '@/stores/navigation';

defineEmits<{
  (e: 'click'): void;
}>();

withDefaults(
  defineProps<{
    hasLink?: boolean;
  }>(),
  {
    hasLink: true
  }
);

// Libs
const navigationStore = useNavigationStore();

const isNavigationMenuExpanded = computed<boolean>(
  () => navigationStore.isNavigationExpanded !== false
);
</script>
